/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */

// Dummy functions for web, Crashlytics is not supported on web

export const init = () => {};
export const setUserId = (_: string) => {};
export const stop = () => {};
export const recordError = () => {};
